import _extends from '@babel/runtime-corejs3/helpers/extends';
import _defineProperty from '@babel/runtime-corejs3/helpers/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/objectWithoutProperties';
import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import _Set from '@babel/runtime-corejs3/core-js-stable/set';
import _Array$isArray from '@babel/runtime-corejs3/core-js-stable/array/is-array';
import React__default, { useRef, useMemo, useEffect, useCallback } from 'react';
import classNames from 'classnames';
import styles from './92eaf70a5288baa390f98abe62f370ca7d0fa305958109435f118350410b09ae.cfe-internal.js';
import '../Checkbox/7c01f064e737dc18a24ac444b04d862febcacfe2a972f7a6e0ab6cb80ee8df17.cfe-internal.js';
import '../../utils/2d829def7915df1f35176a057ded5c77071616520fe7b6b8ef66f5eb29ca849f.cfe-internal.js';
import { useDropdownContext } from './96f486109d0d2850b21eef94a8c44cc3323a66fb525ca5574171063673f9afca.cfe-internal.js';
import { useDropdownHeaderContext } from './c1e6a01ba90d5c5ded3a4403377b02a83d19fc3dff1744450eb179ec9cd1cc80.cfe-internal.js';
import { useChildIndex } from './ChildIndexContext/c457595779a7ac9d386978c8bfe7a9c931826ac323551ee01f4fd049cfaec786.cfe-internal.js';
import wrapEvent from '../../utils/wrapEvent/e6437ee06b490c01a1330c8f2f370768104fbf0b8f6557d196331cda5427061b.cfe-internal.js';
import { FlyoutOption } from '../../utils/Flyout/3d15f309681cace5995cf09f9b9fb203450e2015288fd6455e451778f8a421ad.cfe-internal.js';
import mergeRefs from '../../utils/mergeRefs/836dcb860bec00d9c59bd64df8df6df42430840bc5bfc21b6000935baefbeacd.cfe-internal.js';
import Checkbox from '../Checkbox/bbb86efee75a495b2eb803aad8b5e8c05236c93f8c0727ac51f1a82b7608b17b.cfe-internal.js';

var _excluded = ["children", "value", "label", "onSelect", "onMouseDown", "onMouseEnter", "onMouseLeave", "disabled", "className"];
var DropdownOption = /*#__PURE__*/React__default.forwardRef(function (_ref, ref) {
  var children = _ref.children,
    value = _ref.value,
    label = _ref.label,
    onSelect = _ref.onSelect,
    onMouseDown = _ref.onMouseDown,
    onMouseEnter = _ref.onMouseEnter,
    onMouseLeave = _ref.onMouseLeave,
    disabled = _ref.disabled,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  var internalRef = useRef(null);
  var _useDropdownContext = useDropdownContext(),
    isOpen = _useDropdownContext.isOpen,
    isMultiSelect = _useDropdownContext.isMultiSelect,
    highlightedIndex = _useDropdownContext.highlightedIndex,
    selectedValue = _useDropdownContext.value,
    onOptionSelected = _useDropdownContext.onOptionSelected,
    setHighlightedIndex = _useDropdownContext.setHighlightedIndex,
    listRef = _useDropdownContext.listRef,
    isKeyboardUser = _useDropdownContext.isKeyboardUser,
    setIsKeyboardUser = _useDropdownContext.setIsKeyboardUser,
    searchValue = _useDropdownContext.searchValue,
    isSearchFilteringDisabled = _useDropdownContext.isSearchFilteringDisabled,
    isSearchable = _useDropdownContext.isSearchable,
    searchHeight = _useDropdownContext.searchHeight;
  var _useDropdownHeaderCon = useDropdownHeaderContext(),
    setVisibleChildIds = _useDropdownHeaderCon.setVisibleChildIds;
  var isVisible = useMemo(function () {
    var _context;
    return isSearchFilteringDisabled || !label || !searchValue || typeof label === 'string' && _includesInstanceProperty(_context = label.toLowerCase()).call(_context, searchValue.toLowerCase());
  }, [isSearchFilteringDisabled, label, searchValue]);
  useEffect(function () {
    setVisibleChildIds === null || setVisibleChildIds === void 0 || setVisibleChildIds(function (visibleChildIds) {
      var duplicateSet = new _Set(visibleChildIds);
      if (isVisible) {
        return duplicateSet.add(value);
      }
      duplicateSet["delete"](value);
      return duplicateSet;
    });
  }, [setVisibleChildIds, isVisible, value]);
  var isSelected = _Array$isArray(selectedValue) ? _includesInstanceProperty(selectedValue).call(selectedValue, value) : value === selectedValue;
  var handleSelect = useCallback(function (e) {
    if (!disabled) {
      var handler = wrapEvent(onSelect, function () {
        return onOptionSelected(value);
      });
      handler(e);
    }
  }, [value, disabled, onSelect, onOptionSelected]);
  var myIndex = useChildIndex({
    element: internalRef.current,
    value: value,
    label: label,
    isSelected: isSelected,
    handleSelect: handleSelect,
    isVisible: isVisible
  });
  var isHighlighted = highlightedIndex === myIndex && myIndex !== -1;
  useEffect(function () {
    if (isHighlighted) {
      var _listRef$current, _listRef$current2, _internalRef$current;
      if (isKeyboardUser && isOpen && internalRef !== null && internalRef !== void 0 && internalRef.current && listRef !== null && listRef !== void 0 && listRef.current && ((_listRef$current = listRef.current) === null || _listRef$current === void 0 ? void 0 : _listRef$current.scrollHeight) > ((_listRef$current2 = listRef.current) === null || _listRef$current2 === void 0 ? void 0 : _listRef$current2.clientHeight)) {
        var scrollBottom = listRef.current.clientHeight + listRef.current.scrollTop;
        var elementBottom = internalRef.current.offsetTop + internalRef.current.offsetHeight;
        if (elementBottom > scrollBottom) {
          listRef.current.scrollTop = elementBottom - listRef.current.clientHeight;
        } else if (internalRef.current.offsetTop < listRef.current.scrollTop + (isSearchable ? searchHeight : 0)) {
          listRef.current.scrollTop = internalRef.current.offsetTop - (isSearchable ? searchHeight : 0);
        }
      }
      (_internalRef$current = internalRef.current) === null || _internalRef$current === void 0 || _internalRef$current.focus({
        preventScroll: true
      });
    }
  }, [isHighlighted, isKeyboardUser, isOpen, listRef, isSearchable, searchHeight]);
  return isOpen && isVisible ? /*#__PURE__*/React__default.createElement(FlyoutOption, _extends({}, rest, {
    className: classNames(className, styles.option),
    ref: mergeRefs(internalRef, ref),
    onClick: handleSelect,
    tabIndex: -1,
    isHighlighted: isHighlighted,
    isSelected: isSelected,
    "aria-disabled": disabled,
    onMouseDown: wrapEvent(onMouseDown, function (e) {
      return e.preventDefault();
    }),
    onMouseEnter: wrapEvent(onMouseEnter, function () {
      setIsKeyboardUser(false);
      setHighlightedIndex(myIndex);
    }),
    onMouseLeave: wrapEvent(onMouseLeave, function () {
      return setHighlightedIndex(-1);
    })
  }), children || /*#__PURE__*/React__default.createElement(React__default.Fragment, null, isMultiSelect && /*#__PURE__*/React__default.createElement(Checkbox, {
    className: classNames(styles.checkbox, _defineProperty({}, styles.highlighted, isHighlighted && !isSelected)),
    checked: isSelected,
    onChange: function onChange() {}
  }), label)) : /*#__PURE__*/React__default.createElement("div", {
    ref: internalRef
  });
});
var DropdownOption$1 = DropdownOption;

export { DropdownOption$1 as default };
